<div
  class="upcoming-container"
  appMyMatchHeight="landing-bookings-tile-content"
>
  <div
    *ngIf="bookingList?.length === 0"
    style="padding: 0.75rem 0 0.625rem;"
  >
    <div class="row no-gutters justify-content-center">
      <div class="col-12 col-md order-2 order-md-1 pr-md-1 text-right">
        <button
          class="btn btn-outline-danger no-data-btn"
          routerLink="/interview-request"
        >Request an Interview</button>
      </div>
      <div class="col-12 col-md order-1 order-md-2 pl-md-1 mb-2 mb-md-0">
        <button
          class="btn btn-danger no-data-btn"
          routerLink="/reservation"
        >Book a Reservation</button>
      </div>
    </div>
  </div>

  <!-- carousel -->
  <carousel
    #bookingCarousel
    *ngIf="bookingList?.length > 0 "
    [height]="carouselHeight"
    [margin]="0"
    [cellWidth]="isInMobile ? CAROUSEL_WIDTH_IN_MOBILE : CAROUSEL_WIDTH_DEFAULT"
    [arrows]="!isInMobile && allowScrolling"
    [arrowsOutside]="false"
    [loop]="isInMobile && allowScrolling"
    [dots]="isInMobile && allowScrolling"
  >
    <div
      *ngFor="let item of bookingList"
      class="carousel-cell"
    >
      <app-landing-bookings-tile
        [booking]="item"
        [isMobile]="isInMobile"
      ></app-landing-bookings-tile>
    </div>
  </carousel>
</div>
